import * as React from "react";
import {useTheme} from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {Card, Divider, Grid, Paper} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import {DataGrid, GridActionsCellItem} from "@mui/x-data-grid";
import {GET} from "APIclient";
import {useEffect, useState} from "react";
import {Dialog, DialogTitle, DialogContent, DialogActions, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {Snackbar, Alert} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {TextField} from "@mui/material";
import MDInput from "components/MDInput";
import {InputLabel, Typography, Box} from "@mui/material";
import properties from "constants/ApplicationConstants";
import { formatDesignation } from "constants/ApplicationConstants";

const columns = [
  {field: "id", headerName: "#", width: 50, headerAlign: "left", align: "left"},
  {field: "empId", headerName: "EMP ID", width: 80, headerAlign: "left", align: "left"},
  {
    field: "employeeName",
    headerName: "Employee Name",
    width: 180,
    headerAlign: "left",
    align: "left"
  },
  {field: "designation", headerName: "Designation", width: 200},
  {
    field: "currentCompanyExperience",
    headerName: "BNT Exp (Yrs.)",
    width: 140,
    headerAlign: "center",
    align: "center"
  },
  {
    field: "previousCompanyExperience",
    headerName: "Other Exp (Yrs.)",
    width: 140,
    headerAlign: "center",
    align: "center"
  },
  {
    field: "totalExperience",
    headerName: "Total Exp (Yrs.)",
    width: 140,
    headerAlign: "center",
    align: "center"
  }
];

function Experience_Reports() {
  const empId = Number(window.sessionStorage.getItem("empId"));
  const theme = useTheme();
  const [experienceReports, setExperienceReports] = useState([]);
  const [filteredExperienceReports, setFilteredExperienceReports] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({page: 0, pageSize: 20});
  const [totalItems, setTotalItems] = React.useState(0);
  const [isFetching, setIsFetching] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackColor, setSnackColor] = useState("success");
  const [snackMessage, setSnackMessage] = useState("");

  const [searchInput, setSearchInput] = React.useState("");
  const [searchStatus, setSearchStatus] = React.useState("");

  const handleViewDetails = report => {
    setSelectedReport(report);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedReport(null);
  };

  const handleSearchInputChange = e => {
    setSearchInput(e.target.value);
  };

  const handleSearchStatusChange = e => {
    setSearchStatus(e.target.value);
  };

  const handleSearch = () => {
    onSearch({searchInput, searchStatus});
  };

  const handlePaginationChange = paginationModel => {
    setPaginationModel(paginationModel);
     setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  const fetchExperienceReports = async (page, pageSize) => {
    if (isFetching) return;
    setIsFetching(true);
    try {
      const url = `manager/experience-report?page=${page}&size=${pageSize}&managerId=${empId}`;
      const response = await GET(url);
      if (
        response.status === 200 &&
        response.data &&
        Array.isArray(response.data.data.paginatedData)
      ) {
        const data = response.data.data.paginatedData;
        const totalRecords = response.data.data.totalItems;

        if (data.length === 0) {
          setSnackMessage("No experience reports found.");
          setSnackColor("warning");
          setSnackOpen(true);
          setExperienceReports([]);
          setFilteredExperienceReports([]);
          setTotalItems(0);
          return;
        }

        let index = page * pageSize + 1;
        const formattedData = data.map(item => ({
          id: index++,
          empId: item.empId,
          employeeName: item.employeeName,
          emailAddress: item.emailAddress,
          designation: formatDesignation(item.designation),
          currentCompanyExperience: item.currentCompanyExperience,
          previousCompanyExperience: item.previousCompanyExperience,
          totalExperience: item.totalExperience,
          status: item.status ? "Active" : "Inactive",
          handleView: handleViewDetails
        }));

        setExperienceReports(formattedData);
        setFilteredExperienceReports(formattedData);
        setTotalItems(totalRecords);
      }
    } catch (error) {
      if (error.response) {
        if (
          error.response.status === 400 ||
          error.response.status === 401 ||
          error.response.status === 403
        ) {
          setSnackMessage(error.response.data.message);
          setSnackColor("error");
          setSnackOpen(true);
        }
      } else {
        setSnackMessage("Failed to fetch experience reports.");
        setSnackColor("error");
        setSnackOpen(true);
      }
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchExperienceReports(paginationModel.page, paginationModel.pageSize);
  }, [empId, paginationModel.page, paginationModel.pageSize]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <Card>
            {/* <MDBox
              container
              pt={2}
              mb={2}
              pb={4}
              px={3}
              sx={{ borderRadius: "10px", border: "1px solid #D3D3D3" }}
            >
              <Typography variant="h6" color="textPrimary">
                Search Candidate
              </Typography>
              <MDBox sx={{ display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: 2 }}>
                <InputLabel sx={{ gridColumn: "span 2" }}></InputLabel>
                <MDInput
                  sx={{ gridColumn: "span 3" }}
                  value={searchInput}
                  onChange={handleSearchInputChange}
                  name="serachInput"
                  label="Search Candidate"
                  variant="outlined"
                />
                <MDInput
                  sx={{ gridColumn: "span 3" }}
                  value={searchStatus}
                  onChange={handleSearchStatusChange}
                  name="serachStatus"
                  label="Search Status"
                  variant="outlined"
                />
                <MDButton
                  sx={{ gridColumn: "span 2" }}
                  variant="gradient"
                  color="info"
                  type="button"
                  onClick={handleSearch}
                >
                  Search
                </MDButton>
              </MDBox>
            </MDBox> */}
            
                  
                    <MDBox p={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="bold"
                        sx={{fontFamily: properties.fontFamily}}
                      >
                        Employee Experience List
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <Paper>
                        <DataGrid
                          rows={filteredExperienceReports}
                          columns={columns}
                          paginationMode="server"
                          rowCount={totalItems}
                          pageSizeOptions={[20]}
                          paginationModel={paginationModel}
                          onPaginationModelChange={handlePaginationChange}
                          size="small"
                          sx={{
                            fontWeight:400,
                            fontSize: "14px",
                            fontFamily: properties.fontFamily,
                            height: "515px",
                            "& .MuiDataGrid-scrollbar": {
                              width: "10px !important",
                            },
                          }}
                          aria-label="a dense table"
                        />
                      </Paper>
                    </MDBox>
          </Card>
        </AppBar>
        <Snackbar
          open={snackOpen}
          autoHideDuration={3000}
          onClose={() => setSnackOpen(false)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
        >
          <Alert onClose={() => setSnackOpen(false)} severity={snackColor}>
            {snackMessage}
          </Alert>
        </Snackbar>

        <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
          <DialogTitle
            sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}
          >
            <MDTypography variant="h6">Experience Report Details</MDTypography>
            <IconButton edge="end" color="inherit" onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{padding: 2}}>
            {selectedReport && (
              <form>
                <TextField
                  label="Employee ID"
                  value={selectedReport.empId || "No ID Provided"}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  InputProps={{readOnly: true}}
                />
                <TextField
                  label="Employee Name"
                  value={selectedReport.employeeName || "No Name Provided"}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  InputProps={{readOnly: true}}
                />
                <TextField
                  label="Designation"
                  value={selectedReport.designation || "No Designation Provided"}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  InputProps={{readOnly: true}}
                />
                <TextField
                  label="Current Company Experience"
                  value={selectedReport.currentCompanyExperience || "No Data"}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  InputProps={{readOnly: true}}
                />
                <TextField
                  label="Previous Company Experience"
                  value={selectedReport.previousCompanyExperience || "No Data"}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  InputProps={{readOnly: true}}
                />
                <TextField
                  label="Total Experience"
                  value={selectedReport.totalExperience || "No Data"}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  InputProps={{readOnly: true}}
                />
                <Divider sx={{my: 2}} />
              </form>
            )}
          </DialogContent>
          <DialogActions>
            <MDButton color="secondary" onClick={handleCloseModal} variant="contained">
              Close
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
    </DashboardLayout>
  );
}

export default Experience_Reports;
